import { render, staticRenderFns } from "./CardRight.vue?vue&type=template&id=2edb8434&scoped=true&"
import script from "./CardRight.vue?vue&type=script&lang=js&"
export * from "./CardRight.vue?vue&type=script&lang=js&"
import style0 from "./CardRight.vue?vue&type=style&index=0&id=2edb8434&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2edb8434",
  null
  
)

export default component.exports